import { Link, useParams } from "react-router-dom";
import Breadcrumb from "@/components/base/Breadcrumb";
import NewsCard from "@/components/base/NewsCard";
import { newsList } from "@/mocks/news";
import { formatDate } from "@/utils/format";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NewsDetail() {
  const params = useParams();
  const article = newsList.find((item) => item.id === params.id);

  usePageMeta(
    article ? `${article.title} - 国产久久久` : "资讯详情 - 国产久久久",
    article ? article.summary : "国产久久久影视资讯详情页。",
    article ? `${article.tag},影视资讯,国产久久久` : "影视资讯"
  );

  if (!article) {
    return (
      <div className="w-full px-4 md:px-8 py-20 text-center">
        <span className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-background-100 text-foreground-400 mb-5">
          <i className="ri-file-unknow-line text-3xl"></i>
        </span>
        <h1 className="font-heading text-xl font-semibold text-foreground-950">
          未找到该资讯
        </h1>
        <p className="mt-2 text-sm text-foreground-500">
          这篇资讯可能已被移除，请返回资讯列表继续浏览。
        </p>
        <Link
          to="/news"
          className="inline-block mt-6 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
        >
          返回资讯列表
        </Link>
      </div>
    );
  }

  const others = newsList.filter((item) => item.id !== article.id).slice(0, 3);

  return (
    <div className="w-full">
      <div className="bg-background-100 border-b border-background-200">
        <div className="w-full px-4 md:px-8 py-6">
          <Breadcrumb
            items={[
              { label: "首页", path: "/" },
              { label: "影视资讯", path: "/news" },
              { label: article.title },
            ]}
          />
        </div>
      </div>

      <div className="w-full px-4 md:px-8 py-8 md:py-10">
        <div className="max-w-3xl mx-auto">
          <div className="flex flex-wrap items-center gap-2 mb-4">
            <span className="px-2.5 py-1 rounded-md bg-accent-100 text-accent-800 text-xs">
              {article.tag}
            </span>
            <span className="text-sm text-foreground-500">
              {formatDate(article.date)}
            </span>
          </div>

          <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-snug">
            {article.title}
          </h1>

          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            {article.summary}
          </p>

          <div className="mt-6 w-full aspect-[8/5] rounded-lg overflow-hidden bg-background-200">
            <img
              src={article.cover}
              alt={`${article.title} 配图`}
              title={`${article.title} - 国产久久久`}
              className="w-full h-full object-top object-cover"
            />
          </div>

          <article className="mt-8 flex flex-col gap-5">
            {article.content.map((paragraph, index) => (
              <p
                key={index}
                className="text-sm md:text-base text-foreground-700 leading-loose"
              >
                {paragraph}
              </p>
            ))}
          </article>

          <div className="mt-8 pt-6 border-t border-background-200 flex items-center gap-3">
            <span className="text-sm text-foreground-500">分享</span>
            {["ri-wechat-line", "ri-weibo-line", "ri-link"].map((icon) => (
              <span
                key={icon}
                className="w-9 h-9 flex items-center justify-center rounded-md border border-background-300 text-foreground-600 cursor-pointer hover:border-primary-400 hover:text-primary-600 transition-colors"
              >
                <i className={`${icon} text-lg`}></i>
              </span>
            ))}
          </div>
        </div>

        <div className="max-w-3xl mx-auto mt-12">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-1 h-5 rounded-full bg-primary-500"></span>
            <h2 className="font-heading text-xl font-semibold text-foreground-950">
              相关阅读
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
            {others.map((item) => (
              <NewsCard key={item.id} article={item} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}